import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Switch'
import { DatePicker } from 'material-ui-pickers'
import AutoComplete from '../../../common/auto-complete'
import Y from '../../../y18n'
import * as subscriptionActions from '../../../store/subscriptions-admin/subscription'
import * as userActions from '../../../store/users'
import * as productActions from '../../../store/products'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  subscription: state.subscriptionsAdmin.subscription,
  users: state.users,
  products: state.products
})

const mapDispatchToProps = dispatch => ({
  subscriptionActions: bindActionCreators(subscriptionActions, dispatch),
  userActions: bindActionCreators(userActions, dispatch),
  productActions: bindActionCreators(productActions, dispatch)
})

class EditSubscriptionDialog extends Component {
  state = {
    status: null,
    smsStatus: null,
    changeOwner: false
  }

  componentDidMount() {
    this.props.userActions.getUsers()
    this.props.productActions.getProducts('', 0, 500)
  }

  inputChanged = name => e => {
    this.props.subscriptionActions.updateActive(name, e.target.value)
  }

  submitForm(e) {
    e.preventDefault()
    const {id, startDate, endDate, name, productId, dataUsedMb, smsUsedCount, dataLimitMb, smsLimit ,
    email} = this.props.subscription.active;

    this.props.subscriptionActions.editSubscription(
      {id, startDate, endDate, name, productId, dataUsedMb, smsUsedCount, dataLimitMb, smsLimit,
        email});
  }

  handleDateChange = (e, name) => {
    this.props.subscriptionActions.updateActive(name, e._d)
  }

  handleSearchUsers = e => {
    if (this.state.changeOwner)
      this.setState({ changeOwner: false })
    if (e.value.length > 5) {
      this.props.userActions.clearUsers()
      this.props.userActions.searchUsers(e.value)
    }
  }

  switchChanged = name => e => {
    this.setState({ [name]: e.target.checked })
    this.props.subscriptionActions.changeStatus(name, e.target.checked)
  }

  handleClearUsers = () => {
    if (this.props.users.items.length === 1) {
      this.props.subscriptionActions.updateActive('email', this.props.users.items[0].email)
      this.props.subscriptionActions.updateActive('userId', this.props.users.items[0].id)
      this.props.subscriptionActions.updateActive('customerName', this.props.users.items[0].customerName)
    }
    this.props.userActions.clearUsers()
    this.setState({ changeOwner: true })
  }

  handleUserSelected = (e, { suggestion }) => {
    const userId = suggestion.id
    const email = suggestion.email
    const customerName = suggestion.fullName
    this.props.subscriptionActions.updateActive('email', email)
    this.props.subscriptionActions.updateActive('userId', userId)
    this.props.subscriptionActions.updateActive('customerName', customerName)
  }

  render() {
    const { subscription, users, subscriptionActions, classes } = this.props
    if (!subscription.active || !subscription.edit) return null
    return (
      <Dialog
        open={subscription.edit !== false}
        onClose={() => subscriptionActions.resetActive()}
        aria-labelledby='edit-subscription-dialog'
        scroll='paper'
        classes={{
          paper: classes.dialogContent
        }}
      >
        <form onSubmit={e => this.submitForm(e)}>
          <DialogTitle
            id='edit-subscription-dialog'
            style={{ textAlign: 'center' }}
          >{Y`Edit subscription`}</DialogTitle>
          {subscription.active.isDeleted
            ? <Typography
              variant='body2'
              style={{ textAlign: 'center', color: 'red', paddingBottom: '10px' }}
            >{Y`Subscription deleted by user.`}</Typography>
            : ''}
          <DialogContent>
            <div className={classes.flexRow}>
              <TextField
                margin='normal'
                label={Y`IMSI`}
                type='text'
                value={subscription.active.imsi || ''}
                onChange={this.inputChanged('imsi')}
                className={classes.flexItemLeft}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                disabled
              />
              <TextField
                margin='normal'
                label={Y`MSISDN`}
                type='text'
                value={subscription.active.msisdn || ''}
                onChange={this.inputChanged('msisdn')}
                className={classes.flexItemMiddle}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                disabled
              />
              <TextField
                margin='normal'
                label={Y`ICC`}
                type='text'
                value={subscription.active.icc || ''}
                onChange={this.inputChanged('icc')}
                className={classes.flexItemRight}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                disabled
              />
            </div>
            <div className={classes.flexRow}>
              <TextField
                margin='normal'
                label={Y`Name`}
                type='text'
                value={subscription.active.name || ''}
                onChange={this.inputChanged('name')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                fullWidth
              />
            </div>
            <div className={classes.flexRow}>
              <TextField
                select
                label={Y`Product`}
                value={subscription.active.productId || ''}
                onChange={this.inputChanged('productId')}
                SelectProps={{
                  native: true
                }}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                margin='normal'
                fullWidth
              >
                {this.props.products.items.map(product => (
                  <option key={product.id} value={product.id}>
                    {Y`${product.name}`}
                  </option>
                ))}
              </TextField>
            </div>
            <div className={classes.flexRow}>
              <DatePicker
                keyboard
                clearable
                className={classes.flexItemLeft}
                animateYearScrolling={false}
                label={Y`Start date`}
                format='YYYY-MM-DD'
                value={subscription.active.startDate}
                onChange={e => this.handleDateChange(e, 'startDate')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                InputAdornmentProps={{
                  classes: {
                    root: classes.rightIcon
                  }
                }}
              />
              <DatePicker
                keyboard
                clearable
                className={classes.flexItemRight}
                animateYearScrolling={false}
                label={Y`End date`}
                format='YYYY-MM-DD'
                value={subscription.active.endDate}
                onChange={e => this.handleDateChange(e, 'endDate')}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
                InputAdornmentProps={{
                  classes: {
                    root: classes.rightIcon
                  }
                }}
              />
            </div>
            <div className={classes.flexRow}>
              <TextField
                margin='normal'
                label={Y`Data used` + ' (MB)'}
                type='number'
                value={subscription.active.dataUsedMb}
                onChange={this.inputChanged('dataUsedMb')}
                className={classes.flexItemLeft}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
              />
              <TextField
                margin='normal'
                label={Y`Data limit` + ' (MB)'}
                type='number'
                value={subscription.active.dataLimitMb}
                onChange={this.inputChanged('dataLimitMb')}
                className={classes.flexItemRight}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
              />
            </div>
            <div className={classes.flexRow}>
              <TextField
                margin='normal'
                label={Y`SMS used`}
                type='number'
                value={subscription.active.smsUsedCount}
                onChange={this.inputChanged('smsUsedCount')}
                className={classes.flexItemLeft}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
              />
              <TextField
                margin='normal'
                label={Y`SMS limit`}
                type='number'
                value={subscription.active.smsLimit}
                onChange={this.inputChanged('smsLimit')}
                className={classes.flexItemRight}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.root,
                    input: classes.input
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.formLabel
                }}
              />
            </div>
          </DialogContent>
          <DialogTitle style={{ textAlign: 'center' }}>{Y`Change status`}</DialogTitle>
          <DialogContent style={{ marginTop: '20px', marginBottom: '20px' }}>
            <div
              className={classes.flexRow}
              style={{ justifyContent: 'space-around', paddingLeft: '50px', paddingRight: '50px' }}
            >
              <div className={classes.flexItemLeft} style={{ textAlign: 'center' }}>
                <FormControlLabel
                  control={
                    <Switch
                      classes={{
                        switchBase: classes.iOSSwitchBase,
                        bar: classes.iOSBar,
                        icon: classes.iOSIcon,
                        iconChecked: classes.iOSIconChecked,
                        checked: classes.iOSChecked
                      }}
                      disableRipple
                      checked={this.state.status !== null ? this.state.status : subscription.active.status === 'Active'}
                      onChange={this.switchChanged('status')}
                      value='status'
                    />
                  }
                  label={Y`Data status`}
                />
              </div>
              <div className={classes.flexItemRight} style={{ textAlign: 'center' }}>
                <FormControlLabel
                  control={
                    <Switch
                      classes={{
                        switchBase: classes.iOSSwitchBase,
                        bar: classes.iOSBar,
                        icon: classes.iOSIcon,
                        iconChecked: classes.iOSIconChecked,
                        checked: classes.iOSChecked
                      }}
                      disableRipple
                      checked={
                        this.state.smsStatus !== null
                          ? this.state.smsStatus
                          : subscription.active.smsStatus === 'Active'
                      }
                      onChange={this.switchChanged('smsStatus')}
                      value='smsStatus'
                    />
                  }
                  label={Y`SMS status`}
                />
              </div>
            </div>
          </DialogContent>
          <DialogTitle style={{ textAlign: 'center' }}>{Y`Change owner`}</DialogTitle>
          <DialogContent>
            <div className={classes.flexRow} style={{ marginBottom: '100px' }}>
              <AutoComplete
                label={Y`Email`}
                value={subscription.active.email}
                shouldUpdate={this.state.changeOwner}
                onSuggestionsFetchRequested={this.handleSearchUsers}
                onSuggestionsClearRequested={this.handleClearUsers}
                onSuggestionSelected={this.handleUserSelected}
                suggestions={users.items}
                suggestionProperty='email'
                renderSuggestion={user => (
                  <div>
                    <Typography variant='body2'>{user.firstName} {user.lastName}</Typography>
                    <Typography variant='body1'>{user.email}</Typography>
                  </div>
                )}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => subscriptionActions.resetActive()}>{Y`Close`}</Button>
            {subscription.active.isDeleted
              ? <Button
                onClick={() => subscriptionActions.undoSoftDelete(subscription.active.id)}
                style={{ color: 'red' }}
              >{Y`Restore subscription`}</Button>
              : ''}
            {subscription.loading === true ?
              <Button type='button' variant='raised' style={{ backgroundColor: '#424242', color: '#fff' }}>{Y`Save`}</Button> :
              <Button type='submit' variant='raised' color='primary' style={{ color: '#fff' }}>{Y`Save`}</Button>
            }
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

EditSubscriptionDialog = connect(mapStateToProps, mapDispatchToProps)(EditSubscriptionDialog)
export default withStyles(Styles)(EditSubscriptionDialog)



// WEBPACK FOOTER //
// ./src/pages/subscription-details/containers/edit-subscription-dialog.js